<template>
  <v-dialog v-model="dialog" max-width="600">
    <ValidationObserver ref="importPromoCodeForm" v-slot="{ invalid, passes }">
      <form
        rel="importPromoCodeForm"
        class="flex flex-wrap justify-between sm:justify-center"
        @submit.prevent="passes(submit)"
      >
        <v-card>
          <v-card-title class="pa-7"> Nahrát promo kódy </v-card-title>
          <v-card-text class="pa-7">
            <v-row>
              <v-col cols="12" class="py-0 px-5">
                <VFileInputWithValidation
                  v-model="files"
                  :rules="{
                    required: true,
                    ext: ['xlsx'],
                  }"
                  prepend-icon=""
                  append-icon="$file"
                  :clearable="false"
                  outlined
                  counter
                  :show-size="1000"
                  label="Nahrajte soubor (.xlsx)"
                  @change="setFile($event)"
                />
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions class="pl-7 pr-7 pb-7">
            <v-spacer></v-spacer>
            <v-btn
              type="submit"
              height="40px"
              min-width="130px"
              color="primary"
              depressed
              :loading="saving"
            >
              Nahrát
            </v-btn>
          </v-card-actions>
        </v-card>
      </form>
    </ValidationObserver>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'PromoCodeUploadDialog',
  data() {
    return {
      files: null,
      saving: false,
      dialog: false,
    }
  },
  created() {
    const model = this
    this.$eventBus.$on('promoCodeUploadDialog', function (dialog) {
      model.files = null
      model.dialog = dialog
    })
  },
  methods: {
    ...mapActions({
      importPromoCodes: 'promo/importPromoCodes',
    }),
    setFile(event) {
      this.files = event
    },
    submit() {
      this.saving = true
      this.importPromoCodes({ giftId: this.$route.params.giftId, files: this.files }).finally(
        () => {
          this.saving = false
          this.$refs.importPromoCodeForm.reset()
          this.$emit('promoCodeUploaded')
          this.close()
        }
      )
    },
    close() {
      this.dialog = false
    },
  },
}
</script>
